const SvgMark = ({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`w-7 h-7 ${className}`}
  >
    {children}
  </svg>
);

export const IconYield = () => (
  <SvgMark className="size-7 xl:size-10">
    <path d="M3 24C7 24 9 18 13 18C17 18 15 22 19 14C21 10 24 6 29 5" />
    <circle cx="29" cy="5" r="1.5" fill="currentColor" stroke="none" />
  </SvgMark>
);

export const IconArbitrage = () => (
  <SvgMark className="size-7 xl:size-10">
    <circle cx="11" cy="16" r="7" />
    <circle cx="21" cy="16" r="7" />
  </SvgMark>
);

export const IconSocial = () => (
  <SvgMark className="size-7 xl:size-10">
    <rect x="5" y="9" width="18" height="16" rx="2" />
    <rect x="20" y="5" width="7" height="7" rx="1.5" />
    <line x1="10" y1="16" x2="18" y2="16" />
    <line x1="10" y1="20" x2="16" y2="20" />
  </SvgMark>
);

export const IconPortfolio = () => (
  <SvgMark className="size-7 xl:size-10">
    <rect x="6" y="6" width="20" height="20" rx="2" />
    <line x1="6" y1="14" x2="26" y2="14" />
    <line x1="16" y1="14" x2="16" y2="26" />
  </SvgMark>
);

export const IconAlert = () => (
  <SvgMark className="size-7 xl:size-10">
    <path d="M16 4L28 27H4L16 4Z" />
    <line x1="16" y1="14" x2="16" y2="20" />
    <circle cx="16" cy="23" r="1" fill="currentColor" stroke="none" />
  </SvgMark>
);

export const IconSniper = () => (
  <SvgMark className="size-7 xl:size-10">
    <circle cx="16" cy="16" r="10" />
    <circle cx="16" cy="16" r="3" />
    <circle cx="16" cy="4" r="1.2" fill="currentColor" stroke="none" />
    <circle cx="16" cy="28" r="1.2" fill="currentColor" stroke="none" />
    <circle cx="4" cy="16" r="1.2" fill="currentColor" stroke="none" />
    <circle cx="28" cy="16" r="1.2" fill="currentColor" stroke="none" />
    <line x1="16" y1="6" x2="16" y2="13" />
    <line x1="16" y1="19" x2="16" y2="26" />
    <line x1="6" y1="16" x2="13" y2="16" />
    <line x1="19" y1="16" x2="26" y2="16" />
  </SvgMark>
);

export const IconTrend = () => (
  <SvgMark className="size-7 xl:size-10">
    <path d="M4 24L12 14L18 18L28 6" />
    <path d="M22 6H28V12" />
  </SvgMark>
);

export const IconProcessor = () => (
  <SvgMark className="size-7 xl:size-10">
    <rect x="8" y="8" width="16" height="16" rx="2" />
    <line x1="12" y1="4" x2="12" y2="8" />
    <line x1="20" y1="4" x2="20" y2="8" />
    <line x1="12" y1="24" x2="12" y2="28" />
    <line x1="20" y1="24" x2="20" y2="28" />
    <line x1="4" y1="12" x2="8" y2="12" />
    <line x1="4" y1="20" x2="8" y2="20" />
    <line x1="24" y1="12" x2="28" y2="12" />
    <line x1="24" y1="20" x2="28" y2="20" />
  </SvgMark>
);

export const IconShield = () => (
  <SvgMark className="size-7 xl:size-10">
    <path d="M16 3L28 8V16C28 22 22 27 16 29C10 27 4 22 4 16V8L16 3Z" />
  </SvgMark>
);

export const IconPerson = () => (
  <SvgMark className="size-7 xl:size-10">
    <circle cx="16" cy="10" r="5" />
    <path d="M6 28C6 22 10 18 16 18C22 18 26 22 26 28" />
  </SvgMark>
);

export const IconGlobe = () => (
  <SvgMark className="size-7 xl:size-10">
    <circle cx="16" cy="16" r="12" />
    <ellipse cx="16" cy="16" rx="5" ry="12" />
    <line x1="4" y1="16" x2="28" y2="16" />
  </SvgMark>
);

export const IconLock = () => (
  <SvgMark className="size-7 xl:size-10">
    <rect x="8" y="14" width="16" height="14" rx="2" />
    <path d="M11 14V10C11 7 13 4 16 4C19 4 21 7 21 10V14" />
    <circle cx="16" cy="21" r="1.5" fill="currentColor" stroke="none" />
  </SvgMark>
);

export const IconCard = () => (
  <SvgMark className="size-7 xl:size-10">
    <rect x="3" y="7" width="26" height="18" rx="3" />
    <line x1="3" y1="13" x2="29" y2="13" />
    <line x1="7" y1="20" x2="14" y2="20" />
  </SvgMark>
);
